export const kanbanViewData = {
    taskKanbanView: {
        header: {
            selector: {
                type:        'connect',
                id:          'projectId',
                displayField:     'projectName',
                entity:      'project',
                placeholder: 'kanban.header.project.placeholder',
                modalTitle:  'kanban.header.project.modal.title',
                valueMap: {
                    projectId:   'id',
                    projectName: 'name'
                },
                options:      { withHeaders: false },
                entityParams: { orderBy: 'name', direction: 'asc', serverFilter: 'archived:false' },
                width:        '360px',
            },
            assigneeFilter: {
                type:        'connect',
                id:          'assigneeId',
                displayField:     'assigneeName',
                entity:      'employee',
                placeholder: 'kanban.header.assignee.placeholder',
                modalTitle:  'kanban.header.assignee.modal.title',
                valueMap: {
                    assigneeId:   'id',
                    assigneeName: 'name'
                },
                options:      { withHeaders: false },
                entityParams: { orderBy: 'name', direction: 'asc' },
                width:        '240px',
            }
        },
        emptyLabel: 'kanban.empty.select.project',
        kanbanArea: {
            subEntity:        'projectTask',
            parentPath:       '/project/project',
            statusField:      'status',
            statusNameField:  'statusName',
            stackRankField:   'stackRank',
            defaultStatus:    'backlog',
            // projectTask requires title, status and priority. The board's
            // modal renders the card's first section, which holds none of the
            // last two, so the board has to supply them or the POST is
            // rejected — which is what it was doing.
            defaultPriority:  'medium',
            defaultStackRank: 1000,
            swimlanes: [
                { id: 'backlog', statusValue: 'backlog', title: 'kanban.swimlane.backlog' },
                { id: 'todo', statusValue: 'todo', title: 'kanban.swimlane.todo' },
                { id: 'inProgress', statusValue: 'inProgress', title: 'kanban.swimlane.inProgress' },
                { id: 'inReview', statusValue: 'inReview', title: 'kanban.swimlane.inReview' },
                { id: 'done', statusValue: 'done', title: 'kanban.swimlane.done' }
            ],
            card: {
                titleField:    'title',
                dueDateField:  'dueDate',
                priorityField: 'priority',
                assigneeField: 'assigneeName'
            }
        }
    }
}
